<div class="tabela">
  <table class="custom-table">
    <thead>
      <tr>
        <th *ngFor="let column of columns">
          {{ column.header }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let item of data; let i = index"
        [ngClass]="{
          selected: selectedRowIndex === i
        }"
        (click)="selectRow(i)">
        <td *ngFor="let column of columns">
          <ng-container [ngSwitch]="column.type">
          <span *ngSwitchCase="'text'">
                  <ng-container *ngIf="applyPipe(column, item[column.key]) as res">
                    <ng-container *ngIf="isPipeObj(res); else primitive">
                      <span [ngClass]="res.className ?? null">
                        {{ res.text }}
                        <span *ngIf="res.subText" class="badge-sub-text">{{ res.subText }}</span>
                      </span>
                    </ng-container>

                    <ng-template #primitive>
                      {{ res ?? '—' }}
                    </ng-template>
                  </ng-container>
                </span>

            <div *ngSwitchCase="'textArray'">
              <div class="text-array" *ngIf="column.keyArray">
                <span>{{
                  (item[column.keyArray[0]] ?? '') == ''
                    ? '---'
                    : item[column.keyArray[0]]
                }}</span>
                <span class="text-blue">{{
                  (item[column.keyArray[1]] ?? '') == ''
                    ? '---'
                    : item[column.keyArray[1]]
                }}</span>
              </div>
            </div>

            <ng-container *ngSwitchCase="'select'">
              <div class="custom-select">
                <select
                  [(ngModel)]="item[column.key]"
                  (ngModelChange)="onSelectChange($event, item)">
                  <option
                    *ngFor="let option of sortedColumnOptions(column.options)"
                    [value]="option.value">
                    {{ option.label }}
                  </option>
                </select>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'buttons'">
              <ng-container *ngFor="let btn of column.buttons">
                <ng-container
                  *ngIf="
                    (!btn.condition || btn.condition(item))
                  ">
                  <button (click)="btn.action(item)" [matTooltip]="btn.label" matTooltipPosition="above"
                    matTooltipShowDelay="300">
                    <img class="btn-img" *ngIf="btn.img" [src]="btn.img" />
                    <span class="button" *ngIf="!btn.img">{{ btn.label }}</span>
                  </button>
                </ng-container>
              </ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="'switch'">
              <label class="switch">
                <input
                  type="checkbox"
                  [checked]="item[column.key]"
                  (change)="column.action ? column.action(item) : null" />
                <!-- <input
                  type="checkbox"
                  [checked]="item[column.key]"
                  [disabled]="!viewIcon('Faturar')"
                  (change)="column.action ? column.action(item) : null" /> -->
                <span class="slider round"></span>
              </label>
            </ng-container>

            <ng-container *ngSwitchCase="'checkbox'">
              <label class="checkbox">
                <ng-container
                  *ngIf="shouldShowCheckbox(column, item)">
                  <input
                    type="checkbox"
                    [checked]="item[column.key]"
                    [disabled]="isCheckboxDisabled()"
                    (change)="column.action ? column.action(item) : null" />
                </ng-container>
              </label>
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </tbody>
  </table>
</div>
